import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-problem-arisen',
    templateUrl: './problem-arisen.component.html',
    styleUrls: ['./problem-arisen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProblemArisenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
